if (!customElements.get('casafab-fabric-gallery')) {
  customElements.define('casafab-fabric-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      if (!this.track || this.slides.length < 2) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.inView = false;
      this.index = 0;
      this.button = this.querySelector('[data-gallery-play]');
      this.status = this.querySelector('[data-gallery-status]');
      this.status.textContent = `1 / ${this.slides.length}`;
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => { this.pause(); this.go(this.index - 1); }, {signal});
      this.querySelector('[data-gallery-next]').addEventListener('click', () => { this.pause(); this.go(this.index + 1); }, {signal});
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.refresh(); }, {signal});
      this.track.addEventListener('scroll', () => {
        const origin = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - origin) < Math.abs(this.slides[best].getBoundingClientRect().left - origin) ? index : best, 0);
        this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      }, {signal, passive:true});
      this.track.addEventListener('pointerdown', () => this.pause(), {signal, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.pause(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.addEventListener('mouseenter', () => { this.hovered = true; this.refresh(); }, {signal});
      this.addEventListener('mouseleave', () => { this.hovered = false; this.refresh(); }, {signal});
      this.addEventListener('focusin', event => { if (event.target !== this.button) this.pause(); }, {signal});
      document.addEventListener('visibilitychange', () => this.refresh(), {signal});
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, {signal});
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.refresh(); }, {threshold:0.35});
      this.observer.observe(this);
      this.querySelectorAll('button[hidden]').forEach(button => button.hidden = false);
      this.refresh();
    }
    pause() { this.paused = true; this.refresh(); }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const left = this.slides[next].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({left, behavior:this.motion.matches ? 'instant' : 'smooth'});
    }
    refresh() {
      clearInterval(this.timer);
      this.button.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.button.setAttribute('aria-label',this.paused ? this.dataset.play : this.dataset.pause);
      this.button.setAttribute('aria-pressed', String(!this.paused));
      if (!this.paused && !this.hovered && this.inView && !document.hidden) this.timer = setInterval(() => this.go(this.index + 1), 5000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('casafab-fabric-link')) {
  customElements.define('casafab-fabric-link', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.querySelector('a').addEventListener('click', event => {
        const target = document.getElementById(this.dataset.target);
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
        target.querySelector('h3')?.focus({preventScroll:true});
      }, {signal:this.abort.signal});
      this.observer = new MutationObserver(records => {
        if (records.some(r => r.target.closest?.('[data-variant-content]') || [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('.cf-fabric,[data-variant-content]') || n.querySelector('.cf-fabric'))))) this.sync();
      });
      this.observer.observe(document.body,{childList:true,subtree:true});
      this.sync();
    }
    sync() {
      const target = document.getElementById(this.dataset.target);
      if (!target) { this.hidden = true; return; }
      this.hidden = false;
      const source = target.querySelector('[data-gallery-slide] img, .cf-fabric__image');
      const label = source?.alt || '';
      this.querySelector('[data-fabric-link-label]').textContent = label;
      const holder = this.querySelector('.cf-fabric-link__swatch');
      if (source) {
        let image = holder.querySelector('img');
        if (!image) { image = document.createElement('img'); image.alt=''; image.width=48; image.height=48; image.loading='lazy'; holder.append(image); }
        const url = new URL(source.getAttribute('src'),location.href); url.searchParams.set('width','120');
        image.removeAttribute('srcset'); image.src=url.href;
      } else holder.replaceChildren();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
